export default  {
  host: 'https://learn.gcg.technology',
}